import { createFileRoute } from '@tanstack/react-router'
import { ApiDocsViewer } from '@/components/ApiDocsViewer'
import farmgridLogo from '@/assets/farmgrid-logomark.png'

// @ts-ignore - Route type generation issue in Jest
export const Route = createFileRoute('/api-docs/farmgrid')({
  staticData: {
    title: 'FarmGrid API Docs',
    isSecured: true,
  },
  component: FarmGridApiDocsPage,
})

function FarmGridApiDocsPage() {
  return (
    <div className="-mx-6 -mt-6 h-[calc(100vh-64px)] overflow-hidden">
      <ApiDocsViewer specUrl="/openapi-farmgrid.json" title="FarmGrid API Reference" logo={farmgridLogo} />
    </div>
  )
}
